import { GET_BRANCH_DROP_DOWN_LIST, SET_BRANCH_DROP_DOWN_LIST } from "./BranchType";

const getBranchDropDown = (marketId: any) => ({
    type: GET_BRANCH_DROP_DOWN_LIST,
    marketId
});

const setBranchDropDown = (response: any) => ({
    type: SET_BRANCH_DROP_DOWN_LIST,
    response
});

export {
    getBranchDropDown,
    setBranchDropDown
}